/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teary_Tasty_Warthog_GulpInputs */

const fr_teary_tasty_warthog_gulp = /** @type {(inputs: Teary_Tasty_Warthog_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'expiration modifiée`)
};

/**

* @param {Teary_Tasty_Warthog_GulpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teary_tasty_warthog_gulp = /** @type {((inputs?: Teary_Tasty_Warthog_GulpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teary_Tasty_Warthog_GulpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teary_tasty_warthog_gulp(inputs)
});